/* Sveacarbon – build discount, made visible in the cart drawer and on the cart page.
   The bundle discount is a line-level automatic discount, so Impact's cart-level discount
   block never renders it. This adds one compact row above the Total, plus a note that
   customisation add-ons are excluded. Read-only: it never changes the cart. */
(function () {
  if (window.__scCartSavings) return;
  window.__scCartSavings = true;

  var MARK = 'sc-cart-savings';
  var CSS = '.sc-cart-savings{display:grid;gap:.35rem;padding:.75rem 0;margin-bottom:.25rem;border-top:1px solid rgb(var(--text-color)/.14)}'
    + '.sc-cart-savings__row{display:flex;justify-content:space-between;align-items:baseline;gap:1rem;font-size:.9375rem;font-weight:600;font-variant-numeric:tabular-nums}'
    + '.sc-cart-savings__note{margin:0;font-size:.75rem;line-height:1.45;color:rgb(var(--text-color)/.62)}';
  (function () { var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st); })();
  var isAddon = function (item) { return /^addon-/.test(item.handle || ''); };

  function money(cents, fmt) {
    var v = cents / 100, two = v.toFixed(2), p = two.split('.'), int = p[0], dec = p[1];
    var grp = function (s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    var f = fmt || '{{amount}}';
    var rx = function (k) { return new RegExp('\\{\\{\\s*' + k + '\\s*\\}\\}'); };
    return f
      .replace(rx('amount_no_decimals_with_comma_separator'), grp(Math.round(v).toString(), ','))
      .replace(rx('amount_no_decimals_with_space_separator'), grp(Math.round(v).toString(), ' '))
      .replace(rx('amount_with_comma_separator'), grp(int, '.') + ',' + dec)
      .replace(rx('amount_with_space_separator'), grp(int, ' ') + ',' + dec)
      .replace(rx('amount_no_decimals'), grp(Math.round(v).toString(), ','))
      .replace(rx('amount'), grp(int, ',') + '.' + dec);
  }

  function summarise(cart) {
    var saved = 0, pct = 0, parts = 0, addons = 0;
    (cart.items || []).forEach(function (item) {
      if (isAddon(item)) { addons += item.quantity; return; }
      parts += item.quantity;
      (item.line_level_discount_allocations || []).forEach(function (a) {
        var title = (a.discount_application && a.discount_application.title) || '';
        if (!/build bundle/i.test(title)) return;
        saved += a.amount;
        var m = title.match(/(\d+)\s*%/);
        if (m) pct = Math.max(pct, parseInt(m[1], 10));
      });
    });
    return { saved: saved, pct: pct, parts: parts, addons: addons };
  }

  /* The total row is the only .h-stack that holds two .h5 children. */
  function totalRows() {
    var out = [];
    document.querySelectorAll('.h-stack').forEach(function (row) {
      if (row.closest('.' + MARK)) return;
      if (row.querySelectorAll('.h5').length >= 2) out.push(row);
    });
    return out;
  }

  /* render() writes into the cart drawer, which the MutationObserver below watches.
     Without this flag every paint would re-trigger the observer and poll /cart.js forever. */
  var painting = false;

  function render(cart) {
    painting = true;
    try {
      document.querySelectorAll('.' + MARK).forEach(function (n) { n.remove(); });
      var s = summarise(cart);
      if (!s.saved || !s.pct) return;
      totalRows().forEach(function (row) {
        var box = document.createElement('div');
        box.className = MARK;
        box.innerHTML =
          '<div class="' + MARK + '__row"><span>Build discount &middot; ' + s.pct + ' %</span>' +
          '<span>You saved ' + money(s.saved, window.__scMoneyFormat) + '</span></div>' +
          '<p class="' + MARK + '__note">Already deducted from your ' + s.parts +
          (s.parts === 1 ? ' carbon part' : ' carbon parts') +
          (s.addons ? '. Fade, lacquered fade and custom design are not included in the build discount.' : '.') + '</p>';
        row.parentNode.insertBefore(box, row);
      });
    } finally {
      setTimeout(function () { painting = false; }, 0);
    }
  }

  function isOurs(n) {
    return n.nodeType === 1 && (n.classList.contains(MARK) || (n.closest && !!n.closest('.' + MARK)));
  }
  function onlyOurs(rec) {
    var nodes = Array.prototype.slice.call(rec.addedNodes).concat(Array.prototype.slice.call(rec.removedNodes));
    if (!nodes.length) return true;
    return nodes.every(isOurs);
  }

  var timer = null;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }, 120);
  }

  document.addEventListener('DOMContentLoaded', function () {
    refresh();
    document.documentElement.addEventListener('cart:refresh', refresh);
    document.documentElement.addEventListener('cart:change', refresh);
    var drawer = document.getElementById('cart-drawer');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(function (records) {
        if (painting) return;
        for (var i = 0; i < records.length; i++) {
          if (!onlyOurs(records[i])) { refresh(); return; }
        }
      }).observe(drawer, { childList: true, subtree: true });
    }
  });
})();
